import _without from 'lodash/without';

export const removeFromArray = (array, ...values) => _without(array, ...values);